import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import CommunityForumPosts from "./community-forum";
import IntroCard from './card/IntroCard';
import { MyEventCalendar } from 'mykademy-learner-student-dashboard';
import 'mykademy-learner-student-dashboard/dist/index.css'
import 'mykademy-learner-student-dashboard/dist/scss/student-dashboard/main.css';

import { encode } from 'js-base64';

import LearnerHeading from './card/LearnerHeader';
import LearningProgress from './card/LearningProgress';
import CoursesApprenticeshipTabs from "./courses-apprenticeship-tabs/CoursesApprenticeshipTabs";
import AchievementsCounter from "./card/AchievementsCounter";
import MyActivities from './card/MyActivities';
import UpcomingEventsCarousel from './events/UpcomingEventsCarousel';
import DashboardNotification from './card/DashboardNotification';
import ModalAnnouncement from './ModalAnnouncement';
import { exclamationIcon, pieIcon } from '../../constants/icons';
import RemindersSlider from './card/RemindersSlider';
import DashboardNavigationBar from './DashboardNavigationBar';
import { getEnrolledEvents } from '../../../api/afterLogin/events';
import { getEnrolledCourses } from "../../../api/afterLogin/courses";
import { getCertificates } from '../../../api/afterLogin/certificates';
import { getApprenticeshipList } from "../../../api/afterLogin/apprenticeShip";
import { courseMaterialUrl, imageSrc } from "../../../helpers/url_helper";
import { pluralize } from '../../../helpers/string_helper';
import { EnrollmentProgressLoader } from '../Loader';
import NoItems from './courses/NoItems';
import { checkDisabledSp } from '../../../helpers/permission_helper'; 
import { format } from 'date-fns';
import { decryptData } from '../../../helpers/crypto_helper';

const Dashboard = ({ className, hideApprenticeship, spAuthTokens }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const notificationRef = useRef(null);
  const [notificationHeight, setNotificationHeight] = useState(0);
  const [selectedMenu, setSelectedMenu] = useState("Newsfeed");
  const [hasPostsData, setHasPostsData] = useState(false);
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [totalSlides, setTotalSlides] = useState(0);
  const configData = useSelector((state) => state.config);
  const adminData  = useSelector((state) => state.admin);
  const paths = useSelector((state) => state.user.paths);
  const learner     = configData.session;
  const certificateCounts = useSelector((state) => state.setting.certificatecount);
  const informationBars = useSelector((state) => state.user.headerMenus.information_bars);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [totalUpcomingEvents, setTotalUpcomingEvents] = useState(0);
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [showCourseViewAllBtn, setShowCourseViewAllBtn] = useState(false);
  const [hasEnrolledCourses, setHasEnrolledCourses] = useState(false);
  const [resumeCourse, setResumeCourse] = useState();
  const [statusCounts, setStatusCounts] = useState([]);
  const [isCourseLoading, setIsCourseLoading] = useState(true);
  const [hasResumeCourse, setHasResumeCourse] = useState(true);
  const [certificateData, setCertificateData] = useState(0);

  // FLASH NOTIFICATION
  const [notificationPopup, setNotificationPopup] = useState([]);
  const [notificationBar, setNotificationBar] = useState([]);
  const NOTIFICATION_STORAGE_KEY = "dashboardNotificationDismissed";

  // CALENDER
  const [authToken, setAuthToken] = useState();
  const [spuid, setSpuid]         = useState();
  const idp                       = configData.idp;
  const secret                    = decryptData(adminData.secret);
  const accountId                 = adminData.account_id;
  const timezone                  = adminData.us_timezone;
  const uuid                      = adminData.us_uid;
  const language                  = adminData.language;

  // APPRENTICESHIP
  const [apprenticeshipList, setApprenticeshipList] = useState([]);
  const [showApprenticeship, setShowApprenticeship] = useState(false);
  const [showApprenticeShipViewAllBtn, setShowApprenticeShipViewAllBtn] = useState(false);
  const [apprenticeShipStatusCounts, setApprenticeShipStatusCounts] = useState([]);
  const [apprenticeShipResumeCourse, setApprenticeShipResumeCourse] = useState([]);
  const products    = adminData.products ?? '';
  const userSpEnabled = adminData?.user_sp_enabled;
  const ePortfolio  = (products !== '' && products.find((product)=> product.sp_slug === "eportfolio")) ?? '';

  // ACCESS CHECK
  const [accessMykademy, setAccessMykademy] = useState(checkDisabledSp('mykademy', products, userSpEnabled));
  const [accessEportfolio, setAccessEportfolio] = useState(checkDisabledSp('eportfolio', products, userSpEnabled));
  const [accessTms, setAccessTms] = useState(checkDisabledSp('tms', products, userSpEnabled));

  const handleSlideChange = (newSlideIndex) => {
    setCurrentSlide(newSlideIndex);
  };

  const handleTotalSlidesUpdate = (total) => {
    setTotalSlides(total);
  };

  const fetchUpcomingEvents = async () => {
    if (accessTms) {
      return false;
    }
    try {
      const upcomingEvents = await getEnrolledEvents(configData.access_token, '', { "enroll_status": ["not-started"], "item_type":"all" });
      if (upcomingEvents) {
        return upcomingEvents;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchEnrollCourses = async () => {
    const params        = { page_limit: 30, offset: 0 };
    // const postParams    = { "enroll_status" : ["not-started", "inprogress", "completed"]}
    if (!accessMykademy) {
      const enrollCourses = await getEnrolledCourses(configData.access_token, params);
      return enrollCourses;
    }
    return false;
  };

  const fetchApprenticeshipList = async () => {
    if (spAuthTokens?.eportfolio !== undefined && spAuthTokens?.eportfolio !== '') {
      try {
        const apprenticeShipResponse = await getApprenticeshipList((ePortfolio && ePortfolio.api_url ? ePortfolio.api_url : null), spAuthTokens.eportfolio, `memberPrograms/${adminData.us_uid}?currentPage=1&perPage=10`);
        return apprenticeShipResponse;
      } catch (error) {
        console.error("Error :", error.message);
        throw error;
      }
    }
  }
  
  const fetchInformationBar = () => {
    try {
      if (informationBars) {
        const dismissedIds = JSON.parse(localStorage.getItem(NOTIFICATION_STORAGE_KEY) || '[]');
        const topBarNotification = informationBars?.filter((item) => item.n_notification_bar_type === '2')?.map((item, index) => ({
                                      id:index,
                                      descDashNotification: item.n_content,
                                      backgroundColor:item.n_background_color,
                                      textColor:item.n_text_color,
                                      image:item.n_image,
                                      link:item.n_link
                                    }))?.filter(notification => !dismissedIds.includes(notification.id)) || [];
        const modalNotification  = informationBars?.filter((item) => item.n_notification_bar_type === '1')?.map((item, index) => ({
                                      title: '',
                                      contentType: item.n_image !== null ? 'image' : 'text',
                                      content: item.n_content,
                                      backgroundColor:item.n_background_color,
                                      textColor:item.n_text_color,
                                      image:item.n_image,
                                      link:item.n_link
                                    })) || [];
        
        setNotificationBar(topBarNotification);
        setNotificationPopup(modalNotification);
      }
    } catch (error) {
      console.error(error)
    }
    
  }

  const fetchCertificates = async () => {
    const products = adminData.products ?? [];
    if(products.length > 0) {
      const certificates = await getCertificates(learner.id, learner.us_uuid, configData.access_token, products, spAuthTokens?.eportfolio);
      if (certificates) {
        setCertificateData(certificates.length);
      }
    }
  }

  useEffect(() => {
    fetchInformationBar();
    fetchCertificates();
    if (notificationRef.current) {
      setNotificationHeight(notificationRef.current.offsetHeight + 24);
    }
    let origin    = window.location.pathname;
    const myArray = origin.split("/");
    if (myArray[1] == "student-dashboard") {
      setSpuid("mykademy")
    } else {
      setSpuid(myArray[1])
    }
    const loadData = async () => {
      try {

        const promises = [
          fetchUpcomingEvents(),
          fetchEnrollCourses(),
        ];

        // FOR APPRENTICESHIP
        if (ePortfolio !== '') {
          promises.push(fetchApprenticeshipList())
        }

        const [eventResponse, courseResponse , apprenticeShipResponse] = await Promise.all(promises);
        // Handle event data
        if (eventResponse && eventResponse.data.length > 0) {
          setUpcomingEvents(eventResponse.data);
          setTotalUpcomingEvents(eventResponse.data.length);
        }
        
        // COURSE DATA
        if (courseResponse && courseResponse.data.length > 0) {
          setEnrolledCourses(courseResponse.data)
          if (courseResponse.total > 10) {
            setShowCourseViewAllBtn(true);
          }
          setHasEnrolledCourses(true);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          // RESUME COURSE DATA
          const hasLastLectureCourseFiltered = courseResponse && courseResponse?.data?.filter(
                                                item => item.last_played_lecture !== null && item.enroll_status !== 'completed' && 
                                                ((item.cs_course_validity_status === '2' || item.cs_course_validity_status === '1') ? new Date(item.cs_end_date).setHours(0, 0, 0, 0) >= today.getTime() : item.cs_course_validity_status === '0' ? true : false
                                                ));
          const noLastLectureCourseDataFiltered = courseResponse && courseResponse?.data?.filter(
                                                  item => item.last_played_lecture === null && item.enroll_status !== 'completed' &&
                                                  ((item.cs_course_validity_status === '2' || item.cs_course_validity_status === '1') ? new Date(item.cs_end_date).setHours(0, 0, 0, 0) >= today.getTime() : item.cs_course_validity_status === '0' ? true : false
                                                  ));
          const hasLastLectureCourseData = hasLastLectureCourseFiltered.length > 0 && hasLastLectureCourseFiltered?.reduce(
                                            (accumulator, current) =>
                                              new Date(current.cs_last_content_delivery_access) > new Date(accumulator.cs_last_content_delivery_access) ? 
                                                current : accumulator
                                          );
          
          const noLastLectureCourseData = noLastLectureCourseDataFiltered.length > 0 && noLastLectureCourseDataFiltered?.reduce(
                                            (accumulator, current) =>
                                              new Date(current.cs_subscription_date) > new Date(accumulator.cs_subscription_date) ? 
                                                current : accumulator
                                          );

          const resumeCourseData = Object.keys(hasLastLectureCourseData).length
            ? hasLastLectureCourseData
            : Object.keys(noLastLectureCourseData).length
            ? noLastLectureCourseData 
            : null;
          
          setResumeCourse(resumeCourseData);
          setHasResumeCourse(resumeCourseData ? true : false);
          setIsCourseLoading(false);

          // ENROLLMENT PROGRESS
          const statusCounts = courseResponse && courseResponse.data.reduce((acc, item) => {
            acc[item.enroll_status.replace('-','')] = (acc[item.enroll_status.replace('-','')] || 0) + 1; // Increment the count for the status
            return acc;
          }, {});
          setStatusCounts(statusCounts);
        } else {
          setHasResumeCourse(false);
          setIsCourseLoading(false);
        }


        // APPRENTICESHIP 
        if (apprenticeShipResponse && apprenticeShipResponse?.programs) {
          setApprenticeshipList(apprenticeShipResponse?.programs);
          const apprenticeShipStatusCounts = apprenticeShipResponse && apprenticeShipResponse?.programs.reduce((acc, item) => {
            acc[item.program_status.replace(' ','').toLowerCase()] = (acc[item.program_status.replace(' ','').toLowerCase()] || 0) + 1;
            return acc;
          }, {});
          setApprenticeShipStatusCounts(apprenticeShipStatusCounts);
          setShowApprenticeship(true);
          if (apprenticeShipResponse.meta.totalMemberPrograms > 10) {
            setShowApprenticeShipViewAllBtn(true)
          }

          const apprenticeShipCourseData = (() => {
            // Filter all 'In Progress'
            const inProgress = apprenticeShipResponse && apprenticeShipResponse?.programs
              .filter(p => p.program_status === 'In Progress')
              .sort((a, b) => new Date(b.last_assessed_at) - new Date(a.last_assessed_at));

            if (inProgress.length > 0) return inProgress[0];
          
            // If no 'In Progress', fallback to latest 'Not Started'
            const notStarted = apprenticeShipResponse && apprenticeShipResponse?.programs
              .filter(p => p.program_status === 'Not Started')
              .sort((a, b) => new Date(b.last_assessed_at) - new Date(a.last_assessed_at));
          
            return notStarted[0];
          })();

          const apprenticeShipResumeCourse = {
            enroll_status: apprenticeShipCourseData?.program_status === 'In Progress' ? 'inprogress' : 'not-started',
            cb_slug: apprenticeShipCourseData?.program?.launch_url ?? '',
            cb_image: apprenticeShipCourseData?.program?.program_image_url ?? '',
            cs_end_date: apprenticeShipCourseData?.program?.expiry_date ? format(new Date(apprenticeShipCourseData?.program?.expiry_date), 'MMM dd, yyyy') : '',
            cb_title: apprenticeShipCourseData?.program?.program_name ?? '',
            launch_url: apprenticeShipCourseData?.program?.launch_url ?? '',
            isApprenticeship: true,
            cs_percentage: apprenticeShipCourseData?.submitted_progress ?? 0
          }
          
          if (apprenticeShipCourseData) {
            setApprenticeShipResumeCourse(apprenticeShipResumeCourse)
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    loadData();
  }, [spAuthTokens]);
  
  
  const updateNotificationHeight = () => {
    if (notificationRef.current) {
      setNotificationHeight(notificationRef.current.offsetHeight + 24);
    }else {
      setNotificationHeight(0);
    }
  };

  useEffect(() => {
    updateNotificationHeight();
  }, [notificationBar]);

  const handleNotificationClose = (id) => {
    setNotificationBar((prev) => prev.filter((notif) => notif.id !== id));
  };

  const containerStyle = {
    height: screenWidth < 1199 
      ? `calc(1495px - (9px + ${notificationHeight}px))` 
      : `calc(950px - (21px + ${notificationHeight}px))`,
    overflowY: 'auto',
    transition: 'max-height 0.3s ease',
  };

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleMenuSelection = (menu) => {
    setSelectedMenu(menu);
  };


  const handlePlayCourse = () => {
    console.log('play course');
  }

  const renderSelectedMenuContent = () => {

    switch (selectedMenu) {
      case "Newsfeed":
        return (
          <>
          {notificationBar.length > 0 && (
            <div className="myk__stu-dashbaord_notify-wrapper" ref={notificationRef}>
              <DashboardNotification
                key={notificationBar[0].id}
                {...notificationBar[0]}
                onClose={() => handleNotificationClose(notificationBar[0].id)}
              />
            </div>
          )}
          <div style={containerStyle} className="myk__stu-newsfeeds-mobile-wrapper">
            {spAuthTokens?.newsfeed &&
            <CommunityForumPosts newsfeedSPLunchUrl={spAuthTokens?.newsfeed ?? ''} />
            }
          </div>
          </>
        );
      case "My Learning":
        return (
          <>
            <IntroCard
              slug={resumeCourse?.cb_slug ?? apprenticeShipResumeCourse?.cb_slug ?? ''}
              title={resumeCourse?.enroll_status === 'inprogress' ? 'Resume Learning' : !hasResumeCourse && apprenticeShipResumeCourse?.enroll_status === 'inprogress' ? 'Resume Learning' : 'Start Learning'}
              imgSrc={resumeCourse?.cb_image ? imageSrc('course',resumeCourse?.cb_image, paths) : apprenticeShipResumeCourse?.cb_image}
              deadlineText={`Deadline: ${apprenticeShipResumeCourse?.cs_end_date}`}
              subTitle={resumeCourse?.cb_title ?? apprenticeShipResumeCourse?.cb_title ?? 'Course'}
              progressPercentage={resumeCourse?.cs_percentage ?? apprenticeShipResumeCourse?.cs_percentage ?? 0}
              validityAccessType={resumeCourse?.cs_course_validity_status ?? ''} 
              validityByDays={resumeCourse?.cb_validity ?? ''}
              validityByDate={resumeCourse?.cb_validity_date ?? ''}
              courseDate={resumeCourse?.cs_end_date ?? ''}
              courseStatus={resumeCourse?.enroll_status ?? apprenticeShipResumeCourse?.enroll_status}
              courseStartLink={resumeCourse?.cs_course_id ? courseMaterialUrl(resumeCourse?.cs_course_id,0,'student-dashboard', '/student-dashboard') : apprenticeShipResumeCourse?.isApprenticeship ? apprenticeShipResumeCourse?.launch_url : ''}
              courseResumeLink={resumeCourse?.last_played_lecture && resumeCourse?.last_played_lecture !== null ? courseMaterialUrl(resumeCourse?.cs_course_id,resumeCourse?.cs_last_played_lecture,'student-dashboard', '/student-dashboard') : apprenticeShipResumeCourse?.isApprenticeship ? apprenticeShipResumeCourse?.launch_url : ''}
              isLoading={isCourseLoading}
              render={hasResumeCourse ? hasResumeCourse : apprenticeShipResumeCourse?.isApprenticeship ? true : false}
              hasResumeCourse={hasResumeCourse}
              isApprenticeResumeCourse={apprenticeShipResumeCourse?.isApprenticeship ? true : false}
              apprenticeUrl={apprenticeShipResumeCourse?.launch_url ?? ''}
              accessMykademy={accessMykademy}
              accessEportfolio={accessEportfolio}
            />
            <CoursesApprenticeshipTabs courses={enrolledCourses} showCourseViewAllBtn={showCourseViewAllBtn} hasCourses={hasEnrolledCourses} hideApprenticeship={hideApprenticeship} apprenticeshipList={apprenticeshipList} showApprenticeShipViewAllBtn={showApprenticeShipViewAllBtn} isLoading={isCourseLoading} courseStatusCounts={statusCounts} apprenticeshipStatusCounts={hideApprenticeship === false ? apprenticeShipStatusCounts : 0} certificateCounts={certificateData ?? 0}/>
          </>
        );
      case "Upcoming Events":
        return (
          <>
            {totalUpcomingEvents > 0 && (<LearnerHeading title="Upcoming Events" itemCounter={totalUpcomingEvents} />)}
            {totalUpcomingEvents > 0 && (<UpcomingEventsCarousel className="mb-4" upcomingEvents={upcomingEvents}/>)}
            {spAuthTokens?.mykademy !== '' && spuid &&
              <MyEventCalendar className="mb-4" accessToken={encode(spAuthTokens?.mykademy)} uuid={encode(uuid)} secret={encode(secret)} idp={encode(idp)} accountId={encode(accountId)} spuid={encode(spuid)} timeZone={encode(timezone)} language={encode(language)} />
            }
          </>
        );  
      case "Reminders":
        return (
          <>
            <div className={`myk__stu-reminder-sm ${totalSlides > 0 ? '' : 'no-reminder-slider'}`}>
              <LearnerHeading title="Reminders" svgIcon={exclamationIcon} />
              <RemindersSlider
                ref={sliderRef}
                onSlideChange={handleSlideChange}
                onTotalSlidesUpdate={handleTotalSlidesUpdate}
              />
              <div className="myk__stu-empty-block-reminders">
                <NoItems
                  className="myk_stu-empty-block w-100 px-3"
                  title="No Reminders!"
                  description="Reminders will be displayed here when available."
                />
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };


  return (
    <>
    {screenWidth < 768 && (
      <DashboardNavigationBar onSelect={handleMenuSelection} accessTms={accessTms} />
    )}
    <div className={`${className || ""} community-wrapper myk__stu-dashboard-wrapper`}>
    {screenWidth > 767 && (
      <Row>
        <Col xl={4} lg={6} md={12} className={`mb-3 mb-lg-0 myk__learner-start-col ${!hasPostsData ? 'has-no-newsfeeds' : ''}`}>
          {notificationBar.length > 0 && hasPostsData &&  (
            <div className="myk__stu-dashbaord_notify-wrapper" ref={notificationRef}>
              <DashboardNotification
                key={notificationBar[0].id}
                {...notificationBar[0]}
                onClose={() => handleNotificationClose(notificationBar[0].id)}
              />
            </div>
          )}
          <div style={containerStyle}>
            {spAuthTokens?.newsfeed !== '' &&
            <CommunityForumPosts onPostsDataAvailable={setHasPostsData} newsfeedSPLunchUrl={spAuthTokens?.newsfeed ?? ''}/>
            }
          </div>
        </Col>
        <Col lg={{ span:6, order: 1 }} md={{ span:6, order: 1 }} xl={{ span:5, order: 0 }} className={`myk__learner-center-col ${!hasPostsData ? 'has-no-newsfeeds' : ''}`}
        >
          {screenWidth > 1199 && notificationBar.length > 0 && !hasPostsData && (
            <div className="myk__stu-dashbaord_notify-wrapper" ref={notificationRef}>
              <DashboardNotification
                key={notificationBar[0].id}
                {...notificationBar[0]}
                onClose={() => handleNotificationClose(notificationBar[0].id)}
              />
            </div>
          )}
          {screenWidth > 1199 && (
            <IntroCard
              slug={resumeCourse?.cb_slug ?? apprenticeShipResumeCourse?.cb_slug ?? ''}
              title={resumeCourse?.enroll_status === 'inprogress' ? 'Resume Learning' : !hasResumeCourse && apprenticeShipResumeCourse?.enroll_status === 'inprogress' ? 'Resume Learning' : 'Start Learning'}
              imgSrc={resumeCourse?.cb_image ? imageSrc('course',resumeCourse?.cb_image, paths) : apprenticeShipResumeCourse?.cb_image}
              deadlineText={`Deadline: ${apprenticeShipResumeCourse?.cs_end_date}`}
              subTitle={resumeCourse?.cb_title ?? apprenticeShipResumeCourse?.cb_title ?? 'Course'}
              progressPercentage={resumeCourse?.cs_percentage ?? apprenticeShipResumeCourse?.cs_percentage ?? 0}
              validityAccessType={resumeCourse?.cs_course_validity_status ?? ''} 
              validityByDays={resumeCourse?.cb_validity ?? ''}
              validityByDate={resumeCourse?.cb_validity_date ?? ''}
              courseDate={resumeCourse?.cs_end_date ?? ''}
              courseStatus={resumeCourse?.enroll_status ?? apprenticeShipResumeCourse?.enroll_status}
              courseStartLink={resumeCourse?.cs_course_id ? courseMaterialUrl(resumeCourse?.cs_course_id,0,'student-dashboard', '/student-dashboard') : apprenticeShipResumeCourse?.isApprenticeship ? apprenticeShipResumeCourse?.launch_url : ''}
              courseResumeLink={resumeCourse?.last_played_lecture && resumeCourse?.last_played_lecture !== null ? courseMaterialUrl(resumeCourse?.cs_course_id,resumeCourse?.cs_last_played_lecture,'student-dashboard', '/student-dashboard') : apprenticeShipResumeCourse?.isApprenticeship ? apprenticeShipResumeCourse?.launch_url : ''}
              isLoading={isCourseLoading}
              render={hasResumeCourse ? hasResumeCourse : apprenticeShipResumeCourse?.isApprenticeship ? true : false}
              hasResumeCourse={hasResumeCourse}
              isApprenticeResumeCourse={apprenticeShipResumeCourse?.isApprenticeship ? true : false}
              apprenticeUrl={apprenticeShipResumeCourse?.launch_url ?? ''}
              accessMykademy={accessMykademy}
              accessEportfolio={accessEportfolio}
            />
          )}
          <Row className="myk__dashboard-process">
            {screenWidth > 1368 && (
              <>
                <Col xl="7">
                  <LearnerHeading title="My Enrollment Progress"
                  />
                  {isCourseLoading === false ? 
                  (<LearningProgress courseStatusCounts={statusCounts} apprenticeshipStatusCounts={hideApprenticeship === false ? apprenticeShipStatusCounts : 0} />) :
                  (<EnrollmentProgressLoader />)
                  }
                </Col>
                <Col xl="5">
                  <LearnerHeading title="My Achievement"
                  />
                  {isCourseLoading === false ? 
                  (<AchievementsCounter title={pluralize(certificateCounts,'Certificate')} certificateCounts={certificateData ?? 0}/>) :
                  (<EnrollmentProgressLoader />)
                  }
                </Col>
              </>
            )}
            {screenWidth > 1199 && (
              <Col xl="12">
                <CoursesApprenticeshipTabs courses={enrolledCourses} showCourseViewAllBtn={showCourseViewAllBtn} hasCourses={hasEnrolledCourses} hideApprenticeship={hideApprenticeship} apprenticeshipList={apprenticeshipList}  showApprenticeShipViewAllBtn={showApprenticeShipViewAllBtn} isLoading={isCourseLoading} courseStatusCounts={statusCounts} apprenticeshipStatusCounts={hideApprenticeship === false ? apprenticeShipStatusCounts : 0} certificateCounts={certificateData ?? 0} />
              </Col>
            )}
          </Row>
        </Col>
        <Col xl={3} lg={6} md={12} className={`myk__learner-end-col ${!hasPostsData ? 'has-no-newsfeeds' : ''}`}>
          {screenWidth <= 1199 && notificationBar.length > 0 && !hasPostsData && (
            <div className="myk__stu-dashbaord_notify-wrapper" ref={notificationRef}>
              <DashboardNotification
                key={notificationBar[0].id}
                {...notificationBar[0]}
                onClose={() => handleNotificationClose(notificationBar[0].id)}
              />
            </div>
          )}
          {screenWidth <= 1368 && (
            <>
            <div className={`myk__stu-reminder-md ${totalSlides > 0 ? '' : 'no-reminder-slider'}`}>
              <LearnerHeading title="Reminders" svgIcon={exclamationIcon}/>
              <RemindersSlider 
                ref={sliderRef}
                onSlideChange={handleSlideChange}
                onTotalSlidesUpdate={handleTotalSlidesUpdate} />
            </div>
            </>
          )}
          {totalUpcomingEvents > 0 && (
          <>
          <LearnerHeading title="Upcoming Events" itemCounter={totalUpcomingEvents}/>
          <UpcomingEventsCarousel className="mb-4" upcomingEvents={upcomingEvents} />
          </>
          )}
          {screenWidth > 1199 && (
          <>
            {spAuthTokens?.mykademy !== '' && spuid &&
            <MyEventCalendar className="mb-4" accessToken={encode(spAuthTokens?.mykademy)} uuid={encode(uuid)} secret={encode(secret)} idp={encode(idp)} accountId={encode(accountId)} spuid={encode(spuid)} timeZone={encode(timezone)} language={encode(language)} />
            }
          </>
          )}
          {screenWidth > 1368 && (
            <>
            <LearnerHeading title="My Activities" headerActionBtn="View all"/>
            {spAuthTokens?.eportfolio !== '' && 
            <MyActivities className="mt-4" eportfolioAuthToken={spAuthTokens?.eportfolio} />
            }
            </>
          )}
          {screenWidth <= 1199 && (
            <>
            <IntroCard
              slug={resumeCourse?.cb_slug ?? apprenticeShipResumeCourse?.cb_slug ?? ''}
              title={resumeCourse?.enroll_status === 'inprogress' ? 'Resume Learning' : !hasResumeCourse && apprenticeShipResumeCourse?.enroll_status === 'inprogress' ? 'Resume Learning' : 'Start Learning'}
              imgSrc={resumeCourse?.cb_image ? imageSrc('course',resumeCourse?.cb_image, paths) : apprenticeShipResumeCourse?.cb_image}
              deadlineText={`Deadline: ${apprenticeShipResumeCourse?.cs_end_date}`}
              subTitle={resumeCourse?.cb_title ?? apprenticeShipResumeCourse?.cb_title ?? 'Course'}
              progressPercentage={resumeCourse?.cs_percentage ?? apprenticeShipResumeCourse?.cs_percentage ?? 0}
              validityAccessType={resumeCourse?.cs_course_validity_status ?? ''} 
              validityByDays={resumeCourse?.cb_validity ?? ''}
              validityByDate={resumeCourse?.cb_validity_date ?? ''}
              courseDate={resumeCourse?.cs_end_date ?? ''}
              courseStatus={resumeCourse?.enroll_status ?? apprenticeShipResumeCourse?.enroll_status}
              courseStartLink={resumeCourse?.cs_course_id ? courseMaterialUrl(resumeCourse?.cs_course_id,0,'student-dashboard', '/student-dashboard') : apprenticeShipResumeCourse?.isApprenticeship ? apprenticeShipResumeCourse?.launch_url : ''}
              courseResumeLink={resumeCourse?.last_played_lecture && resumeCourse?.last_played_lecture !== null ? courseMaterialUrl(resumeCourse?.cs_course_id,resumeCourse?.cs_last_played_lecture,'student-dashboard', '/student-dashboard') : apprenticeShipResumeCourse?.isApprenticeship ? apprenticeShipResumeCourse?.launch_url : ''}
              isLoading={isCourseLoading}
              render={hasResumeCourse ? hasResumeCourse : apprenticeShipResumeCourse?.isApprenticeship ? true : false}
              hasResumeCourse={hasResumeCourse}
              isApprenticeResumeCourse={apprenticeShipResumeCourse?.isApprenticeship ? true : false}
              apprenticeUrl={apprenticeShipResumeCourse?.launch_url ?? ''}
              accessMykademy={accessMykademy}
              accessEportfolio={accessEportfolio}
            />
            <CoursesApprenticeshipTabs courses={enrolledCourses} showCourseViewAllBtn={showCourseViewAllBtn} hasCourses={hasEnrolledCourses} hideApprenticeship={hideApprenticeship} apprenticeshipList={apprenticeshipList} showApprenticeShipViewAllBtn={showApprenticeShipViewAllBtn} isLoading={isCourseLoading} courseStatusCounts={statusCounts} apprenticeshipStatusCounts={hideApprenticeship === false ? apprenticeShipStatusCounts : 0} certificateCounts={certificateData ?? 0} />
              {spAuthTokens?.mykademy !== '' && spuid && 
              <MyEventCalendar className="mb-4" accessToken={encode(spAuthTokens?.mykademy)} uuid={encode(uuid)} secret={encode(secret)} idp={encode(idp)} accountId={encode(accountId)} spuid={encode(spuid)} timeZone={encode(timezone)} language={encode(language)} />
              }
            </>
          )}
        </Col>
      </Row>
    )}
    {screenWidth < 768 && (
      <Row>
        <Col xl={4} lg={6} md={12} className="mb-3 mb-lg-0">
        {renderSelectedMenuContent()}
        </Col>
      </Row>
    )}
    </div>
    {notificationPopup && notificationPopup.length > 0  ? (<ModalAnnouncement modals={notificationPopup} />) : ''}
    </>
  );
}

export default Dashboard;
